import React, { useEffect } from "react";

import Navbar from "./Navbar";
// import OpeningIntro from "./Home/MainSlider.jsx";
// import Product from "./Extra/Product";
import ExploreEthiccraft from "./Home/Explore_Ethiccraft";
// import RecentEvents from "./Extra/RecentEvents";
import Testimonials from "./Home/Testimonials_old";
import Ourreach from "./Home/Ourreach";
import Leaders from "./Home/Leaders";
import UpcomingEvents from "./Home/Upcoming_Events";
import SpiritofCelebration from "./Home/SpiritofCelebration";
import OurCauses from "./Home/Our_Causes";
import Footer from "./Footer";
import './Css/Homepage.css'
import Banner from "./Home/MainSlider";
import PhotoCollage from "./Home/Polaroid_Gallery";

function Home() {
  useEffect(() => {
    // ScrollReveal was here, removed to favor AOS/Framer Motion
  }, []);

  return (
    <div>
      <Navbar />
      <Banner />
      <PhotoCollage />
      <UpcomingEvents />
      <Ourreach />
      <ExploreEthiccraft />
      <OurCauses />
      <Leaders />
      <SpiritofCelebration />
      <Testimonials />
      <Footer />
    </div>
  );
}

export default Home;